module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"setTenantCard.name.required":"A name is required for tenants","setTenantCard.currencyCode.required":"A currency code is required for tenants","setTenantCard.mpn":"Microsoft Partner Number","setTenantCard.tagHeirarchy1":"Tag Key 1","setTenantCard.tagHeirarchy2":"Tag Key 2","setTenantCard.tagHeirarchy3":"Tag Key 3"}}')
  delete Component.options._Ctor
}
